import React, {useEffect} from "react";

function Pano(props) {
  let panorama;
  const deconstructedURL = new URL(props.thumbnailUrl);
  const panoID = deconstructedURL.searchParams.get("pano");
  const heading = parseFloat(deconstructedURL.searchParams.get("heading")) || 0;
  const pitch = parseFloat(deconstructedURL.searchParams.get("pitch")) || 0;

  useEffect(() =>{
    initPano();
  }, [props.mapsLoaded])

  const initPano = () => {
    if (window.google) {
      panorama = new window.google.maps.StreetViewPanorama(
        document.getElementById("maptest"),
        {
          pano: panoID,
          pov: { heading: heading, pitch: pitch },
          zoom: 1,
          disableDefaultUI: true,
        }
      );
    }
  };

  return (
      <div
        className={
          "aspect-ratio--object cover bg-custom-dark br3 fit-cover pointer"
        }
        id="maptest"
      ></div>
  );
}

export default Pano;
